/* eslint-disable consistent-return */ // eslint-disable-next-line import/no-extraneous-dependencies
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import checkStandardConditions from './check-standard-conditions';
import checkTotalQuantity from './check-total-quantity';
import checkTotalWeight from './check-total-weight';
import Condition from './condition';
import checkTotalSpend from './check-total-spend';
import { getSpecialSettings, orderProductsForDiscountPrecedence } from '../utilities';
// Sort individual conditions equal to itemToConsiderLast's id at the bottom so other conditions will be satisfied first
var sortConditions = function(conditions, itemToConsiderLast) {
    var __reduce = _sliced_to_array(_.reduce(conditions || [], function(lists, currentCondition) {
        if ((currentCondition === null || currentCondition === void 0 ? void 0 : currentCondition.productId) !== (itemToConsiderLast === null || itemToConsiderLast === void 0 ? void 0 : itemToConsiderLast.id)) {
            lists[0].push(currentCondition);
            return lists;
        }
        lists[1][(currentCondition === null || currentCondition === void 0 ? void 0 : currentCondition.weight) !== (itemToConsiderLast === null || itemToConsiderLast === void 0 ? void 0 : itemToConsiderLast.weight) ? "unshift" : "push"](currentCondition);
        return lists;
    }, [
        [],
        []
    ]), 2), topConditions = __reduce[0], bottomConditions = __reduce[1];
    return _to_consumable_array(topConditions).concat(_to_consumable_array(bottomConditions));
};
var ConditionsManager = /*#__PURE__*/ function() {
    "use strict";
    function ConditionsManager(bogoCalcsData, bogoSpecial, items, globalSpecialsSettings) {
        _class_call_check(this, ConditionsManager);
        this.bogoCalcsData = bogoCalcsData;
        this.bogoSpecial = bogoSpecial;
        this.conditions = _.map(bogoSpecial === null || bogoSpecial === void 0 ? void 0 : bogoSpecial.bogoConditions, function(condition) {
            return new Condition(condition, bogoCalcsData, bogoSpecial, items);
        });
        var _bogoSpecial_bogoConditionLogicOperator;
        this.logicOperator = (_bogoSpecial_bogoConditionLogicOperator = bogoSpecial.bogoConditionLogicOperator) !== null && _bogoSpecial_bogoConditionLogicOperator !== void 0 ? _bogoSpecial_bogoConditionLogicOperator : 'and';
        this.items = items;
        var _bogoSpecial_itemsForAPrice;
        this.itemsForAPrice = (_bogoSpecial_itemsForAPrice = bogoSpecial.itemsForAPrice) !== null && _bogoSpecial_itemsForAPrice !== void 0 ? _bogoSpecial_itemsForAPrice : {
            enabled: false
        };
        var _bogoSpecial_discountBundle;
        this.discountBundle = (_bogoSpecial_discountBundle = bogoSpecial.discountBundle) !== null && _bogoSpecial_discountBundle !== void 0 ? _bogoSpecial_discountBundle : {
            enabled: false
        };
        var _bogoSpecial_discountToCart;
        this.discountToCart = (_bogoSpecial_discountToCart = bogoSpecial.discountToCart) !== null && _bogoSpecial_discountToCart !== void 0 ? _bogoSpecial_discountToCart : {
            enabled: false
        };
        this.previous = {
            satisfied: false,
            satisfiers: {}
        };
        this.satisfied = false;
        this.satisfiers = {};
        // prefer the specials discount settings before falling back to global settings
        this.specialsSettings = getSpecialSettings(bogoSpecial, globalSpecialsSettings);
        var _bogoSpecial_totalQuantity;
        this.totalQuantity = (_bogoSpecial_totalQuantity = bogoSpecial.totalQuantity) !== null && _bogoSpecial_totalQuantity !== void 0 ? _bogoSpecial_totalQuantity : {
            enabled: false
        };
        var _bogoSpecial_totalWeight;
        this.totalWeight = (_bogoSpecial_totalWeight = bogoSpecial.totalWeight) !== null && _bogoSpecial_totalWeight !== void 0 ? _bogoSpecial_totalWeight : {
            enabled: false
        };
        var _bogoSpecial_totalSpend;
        this.totalSpend = (_bogoSpecial_totalSpend = bogoSpecial.totalSpend) !== null && _bogoSpecial_totalSpend !== void 0 ? _bogoSpecial_totalSpend : {
            enabled: false
        };
        this.evaluate({});
    }
    _create_class(ConditionsManager, [
        {
            key: "evaluate",
            value: function evaluate(param) {
                var itemToConsiderLast = param.itemToConsiderLast, pendingRewardsSatisfiers = param.pendingRewardsSatisfiers, itemsOverride = param.itemsOverride;
                var _this_itemsForAPrice, _this_totalSpend, _this_totalWeight, _this_totalQuantity;
                this.previous = {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
                var items = itemsOverride !== null && itemsOverride !== void 0 ? itemsOverride : this.items;
                if (itemsOverride) {
                    // if there is an itemsOverride we want to then make sure those items are also out of the conditions eligible items list for the adv. conditions
                    this.reevaluateConditionsEligibleItems({
                        items: items
                    });
                }
                var satisfied;
                var satisfiers;
                var conditions = itemToConsiderLast && !((_this_itemsForAPrice = this.itemsForAPrice) === null || _this_itemsForAPrice === void 0 ? void 0 : _this_itemsForAPrice.enabled) ? sortConditions(this.conditions, itemToConsiderLast) : this.conditions;
                if ((_this_totalSpend = this.totalSpend) === null || _this_totalSpend === void 0 ? void 0 : _this_totalSpend.enabled) {
                    var ref;
                    ref = checkTotalSpend({
                        bogoCalcsData: this.bogoCalcsData,
                        conditions: conditions,
                        items: items,
                        itemToConsiderLast: itemToConsiderLast,
                        itemsForAPrice: this.itemsForAPrice,
                        discountBundle: this.discountBundle,
                        logicOperator: this.logicOperator,
                        pendingRewardsSatisfiers: pendingRewardsSatisfiers,
                        specialId: this.bogoSpecial.specialId,
                        specialsSettings: this.specialsSettings,
                        totalQuantity: this.totalQuantity,
                        totalSpend: this.totalSpend
                    }), satisfied = ref.satisfied, satisfiers = ref.satisfiers, ref;
                } else if ((_this_totalWeight = this.totalWeight) === null || _this_totalWeight === void 0 ? void 0 : _this_totalWeight.enabled) {
                    var ref1;
                    ref1 = checkTotalWeight({
                        bogoCalcsData: this.bogoCalcsData,
                        conditions: conditions,
                        items: items,
                        itemsForAPrice: this.itemsForAPrice,
                        discountBundle: this.discountBundle,
                        itemToConsiderLast: itemToConsiderLast,
                        logicOperator: this.logicOperator,
                        pendingRewardsSatisfiers: pendingRewardsSatisfiers,
                        specialId: this.bogoSpecial.specialId,
                        specialsSettings: this.specialsSettings,
                        totalQuantity: this.totalQuantity,
                        totalWeight: this.totalWeight
                    }), satisfied = ref1.satisfied, satisfiers = ref1.satisfiers, ref1;
                } else if ((_this_totalQuantity = this.totalQuantity) === null || _this_totalQuantity === void 0 ? void 0 : _this_totalQuantity.enabled) {
                    var ref2;
                    ref2 = checkTotalQuantity({
                        bogoCalcsData: this.bogoCalcsData,
                        conditions: conditions,
                        items: items,
                        itemsForAPrice: this.itemsForAPrice,
                        discountBundle: this.discountBundle,
                        itemToConsiderLast: itemToConsiderLast,
                        logicOperator: this.logicOperator,
                        pendingRewardsSatisfiers: pendingRewardsSatisfiers,
                        specialId: this.bogoSpecial.specialId,
                        specialsSettings: this.specialsSettings,
                        totalQuantity: this.totalQuantity
                    }), satisfied = ref2.satisfied, satisfiers = ref2.satisfiers, ref2;
                } else {
                    var ref3;
                    ref3 = checkStandardConditions({
                        conditions: conditions,
                        continueCheckingConditionsAfterSatisfied: this.itemsForAPrice.enabled,
                        itemToConsiderLast: itemToConsiderLast,
                        logicOperator: this.logicOperator,
                        pendingRewardsSatisfiers: pendingRewardsSatisfiers,
                        items: items,
                        itemsForAPrice: this.itemsForAPrice,
                        specialsSettings: this.specialsSettings
                    }), satisfied = ref3.satisfied, satisfiers = ref3.satisfiers, ref3;
                }
                this.satisfied = satisfied;
                this.satisfiers = satisfied ? satisfiers : {};
                return {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
            }
        },
        {
            key: "revert",
            value: function revert() {
                var newPrevious = {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
                this.satisfied = this.previous.satisfied;
                this.satisfiers = this.previous.satisfiers;
                this.previous = newPrevious;
                _.forEach(this.conditions, function(condition) {
                    return condition.revert();
                });
            }
        },
        {
            key: "reevaluateConditionsEligibleItems",
            value: function reevaluateConditionsEligibleItems(param) {
                var _this = this;
                var items = param.items;
                _.forEach(this.conditions, function(condition) {
                    condition.eligibleItems = orderProductsForDiscountPrecedence(_.intersectionBy(items, condition.eligibleItems, 'key'), _this.specialsSettings, _this.itemsForAPrice.enabled ? 'rewards' : 'conditions');
                });
            }
        }
    ]);
    return ConditionsManager;
}();
export default ConditionsManager;
